// extracted by mini-css-extract-plugin
export const detailPage = "_3Q-DwF";
export const links = "_1O4In1";
export const link = "_1VFFL0";
export const container = "_3A0hrb";
export const emptySection = "_18Qoyx";